import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getPriorityTypes = createAsyncThunk('/getPriorityTypes',
  async () => {
    const response = await axios.get('/GetPriorityTypes');
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);


const priorityTypeSlice = createSlice({
  name: 'priorityType',
  initialState: {
    loading: false,
    error: '',
    priorityTypes:[],
    priorityTypeDescriptions:[],
    SelectedAppTranslationId: 0,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
  },
  extraReducers: {
    [getPriorityTypes.pending]: (state) => {
      state.loading = true;
    },
    [getPriorityTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPriorityTypes.fulfilled]: (state, action) => {
      state.priorityTypes= action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.priorityTypeDescriptions = action.payload;
      state.loading = false;
    },
  }
});
export const priorityTypeActions = priorityTypeSlice.actions;

export default priorityTypeSlice;